import React from "react";
import { useParams } from "react-router-dom";

import {
  Box,
  Grid,
  Typography,
} from "@mui/material";

import DetailsView from "../Common/Views/DetailsView";
import ItemsList from "./ItemsList";
import { itemTypeToLabel } from './itemUtils';

function ItemCategoryDetailsLayout({ data, reload }) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} lg={4}>
        <Typography variant="subtitle2" color="text.secondary">
          Name
        </Typography>
        <Typography variant="body2">{data.name || "-"}</Typography>
      </Grid>

      <Grid item xs={12} sm={6} lg={4}>
        <Typography variant="subtitle2" color="text.secondary">
          Type
        </Typography>
        <Typography variant="body2">{data.type ? itemTypeToLabel(data.type) : "-"}</Typography>
      </Grid>

      <Grid item xs={12} sm={6} lg={4}>
        <Typography variant="subtitle2" color="text.secondary">
          Active status
        </Typography>
        <Typography
          variant="body2"
          color={data.isActive ? 'success.main' : 'warning.main'} // green for active, orange for inactive
          fontWeight={!data.isActive ? '600' : '400'} // bold for inactive
        >
          {data.isActive ? "Active" : "Inactive"}
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography variant="subtitle2" color="text.secondary">
          Description
        </Typography>
        <Typography
          variant="body2"
          sx={{ whiteSpace: 'pre-line' }}
        >{data.description || "-"}</Typography>
      </Grid>
    </Grid>
  );
}

export default function ItemCategoryDetails() {
  const { id } = useParams();

  // Determine type path segment from the URL
  const isServiceCategory = window.location.pathname.includes('/categories/services/');
  const typePathSegment = isServiceCategory ? 'services' : 'products';

  return (
    <>
      <DetailsView
        title="Item Category details"
        subtitleAttribute="name"
        apiPath={`/tenants/items/categories/${id}`}
        editPath={`/items/categories/${typePathSegment}/${id}/edit`}
        onDelete={(data) => {
          console.log("Delete action for", data);
          // you can plug API delete call here
        }}
      >
        {({ data, reload }) => <ItemCategoryDetailsLayout data={data} reload={reload} />}
      </DetailsView>

      <Box margin={{ xs: 1, sm: 2 }} mt={{ xs: 2, sm: 4 }} padding={{ xs: 1, sm: 2 }}>
        <ItemsList
          title="Items in this category"
          filters={{ itemCategoryId: id }}
          addButton={true}
          addButtonLabel={`Add new ${isServiceCategory ? 'service' : 'product'}`}
          addButtonPath={`/items/${typePathSegment}/add`}
          columns={['name', 'code', 'brand', 'model', 'uom', 'hasInventory']}
          searchBox={false}
          noResultsMessage="No items found for this category"
        />
      </Box>
    </>
  )
}